import store from '../store';

async function loadAppData() {
  // console.log('init');
  if (store.getters['organisation/initialized']) {
    return Promise.resolve();
  }
  const errors = [];
  const loadingData = [
    {
      name: 'organisation/fetchOrganisations',
      payload: null,
      message: 'Loading organisation...',
      callback: (response) => {
        if (!response.data.length) {
          errors.push('No organisations available.');
        }
      },
    },
    {
      name: 'user/fetchUser',
      payload: null,
      message: 'Loading user data...',
      callback: (response) => {
        if (!response.data.length) {
          errors.push('No user data available.');
        }
      },
    },
  ];

  const requests = [];

  loadingData.forEach((action) => {
    if (action.initial !== false) { // add check in the store
      store.dispatch('organisation/setSplashMessage', action.message);
      const request = store.dispatch(action.name, action.payload);
      request
        .then(action.callback)
        .catch(error => errors.push(error.message));

      requests.push(request);
    }
  });

  return Promise.all(requests).then(() => {
    store.dispatch('organisation/initialized', true);
    store.dispatch('organisation/splashProgressIncrease');
  });
}

function updateAppData() {

}

export { loadAppData, updateAppData };
